import React from "react";
import Spinner from "react-bootstrap/Spinner";
import styled, { css } from "styled-components";
import { colors } from "@theme/theming";

type Props = {
	absolutePosition?: boolean;
};

export default function LoadingIndicator(props: Props) {
	const isOverlay = props.absolutePosition ?? true;
	return (
		<LoadingBackground absolutePosition={props.absolutePosition}>
			<SpinnerWrapper $sticky={isOverlay}>
				<StyledSpinner animation="border" />
			</SpinnerWrapper>
		</LoadingBackground>
	);
}

const LoadingBackground = styled.div`
	${(props: Props) =>
		props.absolutePosition ?? true
			? css`
					position: absolute;
					top: 0;
					left: 0;
					/* the spinner is kept in view by sticky, which can only push it down */
					align-items: flex-start;
			  `
			: css`
					position: relative;
					align-items: center;
			  `};
	display: flex;
	justify-content: center;
	/* must stay above the sticky table headers (z-index 99) it dims */
	z-index: 100;
	background: ${colors.gray.g100}80;
	width: 100%;
	height: 100%;
`;

const SpinnerWrapper = styled.div`
	${(props: { $sticky: boolean }) =>
		props.$sticky
			? css`
					position: sticky;
					top: 45vh;
			  `
			: ""};
`;

const StyledSpinner = styled(Spinner)`
	color: ${colors.primary.p200};
`;
